import { alpha, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  searchRoot: {
    position: 'relative',
    width: '100%',
    '& .MuiSvgIcon-root': {
      position: 'absolute',
      left: 10,
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 1,
      color: theme.palette.text.secondary,
      fontSize: 20,
    },
    '& .MuiInputBase-root': {
      width: '100%',
    },
    '& .MuiInputBase-input': {
      height: 36,
      borderRadius: 4,
      border: `1px solid ${theme.palette.borderColor.main}`,
      color: theme.palette.text.disabled,
      boxSizing: 'border-box',
      padding: '5px 15px 5px 35px',
      transition: 'all 0.3s ease',
      fontSize: 14,
      color: '#000',
      //   boxShadow: '0 0px 8px 0 rgb(0 0 0 / 8%)',
      '&::placeholder': {
        color: '#333',
      },
      '&:focus': {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  filterList: {
    textAlign: 'right',
    padding: '0',
    '& li': {
      padding: '0',
    },
  },
  innerFilterList: {
    // border: '1px solid #cccccc',
    padding: '4px 8px',
    borderRadius: '4px',
    background: '#ffffff',
    boxShadow: '0 0px 8px 0 rgb(0 0 0 / 8%)',

    '& li': {
      padding: '4px',
    },
  },
  sortListItem: {
    '& input': {
      minHeight: '32px',
    },
  },
}));

export default useStyles;
